(function () {
  if (window.__bizOppInitialized) return;
  window.__bizOppInitialized = true;

  var initializedSections = new WeakSet();

  function initSection(root) {
    if (!root || initializedSections.has(root)) return;
    initializedSections.add(root);

    var revealEls = root.querySelectorAll('[data-bo-reveal]');
    revealEls.forEach(function (el, i) {
      el.style.setProperty('--stagger', (i * 100) + 'ms');
    });

    if (!('IntersectionObserver' in window)) {
      root.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('is-visible', entry.isIntersecting);
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -40px 0px' }
    );

    observer.observe(root);
  }

  function initAll() {
    document.querySelectorAll('[data-biz-opp]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-biz-opp]');
    if (root) {
      initializedSections.delete(root);
      root.classList.remove('is-visible');
      initSection(root);
    }
  });
})();